/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// utils
import { url } from 'utils/urls';
// material
import { SingleSelectDropDown, TextField } from '@insticator/insticator-ui'
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './sortconfig_styles'
import PreviewConfig from 'material/previewconfig/previewconfig'
import ArticleCard from 'material/articlecard/articleccard';
import { setTrendingNowConfigSectionValid } from 'state/slices/trendingnowv2';
import { useDispatch } from 'react-redux';

const sortingPreferenceOptionList = [
  { name: 'Most comments', option: 'Most comments', value: 'MOST_COMMENTS'},
  { name: 'Most reactions', option: 'Most reactions', value: 'MOST_REACTIONS'},
  { name: 'Most page views', option: 'Most page views', value: 'MOST_VIEWS'},
]

const sortingPreferenceOption = {
  'MOST_COMMENTS': sortingPreferenceOptionList[0],
  'MOST_REACTIONS': sortingPreferenceOptionList[1],
  'MOST_VIEWS': sortingPreferenceOptionList[2]
}

const timeframeOptionList = [
  { name: 'Past 24 hours', option: 'Past 24 hours', value: 'DAY'},
  { name: 'Past 7 days', option: 'Past 7 days', value: 'WEEK'},
  { name: 'Past 30 days', option: 'Past 30 days', value: 'MONTH'},
  { name: 'Custom', option: 'Custom', value: 'CUSTOM'}
]

const timeframeOption = {
  'DAY': timeframeOptionList[0],
  'WEEK': timeframeOptionList[1],
  'MONTH': timeframeOptionList[2],
  'CUSTOM': timeframeOptionList[3]
}

const sortPreviews = {
  MOST_COMMENTS: [{totalComments: 200}, {totalComments: 100}],
  MOST_REACTIONS: [{totalReactions: 200}, {totalReactions: 100}],
  MOST_VIEWS: [{totalViews: 200}, {totalViews: 100}],
}


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : HEADER TITLE ~~~~~~~~~~ ========== */
const SortConfig = injectSheet(styles)((props) => {

  const dispatch = useDispatch()
  const { sortingPreference, timeframe, customTimeframeUnit, onChange } = props

  useEffect(() => {
    // Validate general section
    const isValidTimeframeUnit = timeframe === 'CUSTOM' ? (customTimeframeUnit > 0 && customTimeframeUnit < 366)   : true
    dispatch(setTrendingNowConfigSectionValid({ configName: 'generalConfig', isValid: isValidTimeframeUnit }))
  }, [timeframe, customTimeframeUnit, dispatch])

  const handleSortConfigChange = (newProperty) => {
    const currentProperties = {
      sortingPreference,
      timeframe,
      customTimeframeUnit: newProperty.timeframe === 'CUSTOM' && customTimeframeUnit === 0 ? 1 : customTimeframeUnit
    }
    onChange({ sortConfig: {...currentProperties, ...newProperty}})
  }

  const handleSelectSortingPreference = opt => handleSortConfigChange({ sortingPreference: opt.value })

  const handleSelectTimeframe = opt => handleSortConfigChange({ timeframe: opt.value })

  return (
    <SectionGroupV2 
      indented={true} 
      klass={`sortconfig ${props.classes.sortconfig}`} 
      title={'Method to select articles'} 
      description={'Select the sorting and timeframe determining order of articles.'}
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <Space direction={'column'}>
            <div className='sortby'>
              <SingleSelectDropDown 
                name={`${sortingPreferenceOption[sortingPreference].name}`} 
                label={'Sort'}
                searchable={false} 
                onSelect={handleSelectSortingPreference}
                items={sortingPreferenceOptionList}
              />
            </div>
            <Space alignItems={'end'}>
              <Space direction={'column'}>
              <label>Timeframe</label>
              <SingleSelectDropDown 
                name={timeframeOption[timeframe].name} 
                searchable={false} 
                onSelect={handleSelectTimeframe}
                items={timeframeOptionList}
              />
              </Space>

              {timeframe === 'CUSTOM' && (
                <Space alignItems={'center'}>
                  <TextField
                    type={'number'}
                    name={'customTimeframeUnit'}
                    value={customTimeframeUnit}
                    handleChange={e => handleSortConfigChange({ customTimeframeUnit: e.target.value})}
                    valid={timeframe === 'CUSTOM' && customTimeframeUnit > 0 && customTimeframeUnit < 366} 
                    min={1}
                    max={365}
                  />
                  <span className='dayslabel'>days</span>
                </Space>
              )}
            </Space>
            {timeframe === 'CUSTOM' && (customTimeframeUnit < 1 || customTimeframeUnit > 365) && (
              <span className='errormessage'>Custom timeframe should be atleast 1 day up to 365 days</span>
            )}
          </Space>
          <PreviewConfig>
            <div className='container'>
              <ArticleCard 
                title={'Sample article headline from your site'} 
                {...sortPreviews[sortingPreference][0]}
                imageSrc={`${url.image}/2.0/trendingnow/article-image-2.jpg`}
              />
              <ArticleCard 
                title={'Sample article headline from your site'} 
                {...sortPreviews[sortingPreference][1]}
                imageSrc={`${url.image}/2.0/trendingnow/article-image-3.jpg`}
              />
            </div>
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SortConfig;